import { type ErrorBoundaryProps, ErrorState } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

export default function SearchError({ error, reset }: ErrorBoundaryProps) {
  const t = useT()
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('Failed to load Ondit Search')}
      description={t(
        'Something went wrong while loading your Ondit Search connectors. Please try again.'
      )}
      loggerName='SearchError'
    />
  )
}
